import React from 'react'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import useCurrentUser from 'lib/hooks/useCurrentUser'

import AppContext from 'components/AppContext'

import './user-edit-header.pcss'

const UserEditHeader = () => {
    const currentUser = useCurrentUser()

    const user = currentUser.me.user

    const { t } = useTranslation('editProfile')

    return (
        <AppContext context="header">
            <div className="user-edit-header">
                <div className="user-edit-header__content">
                    <div className="user-edit-header__body">
                        <h1 className="user-edit-header__title">
                            {t('editProfile:title')}
                        </h1>
                        <p className="user-edit-header__sub-title">
                            {user.firstName} {user.lastName}
                        </p>
                    </div>
                </div>
            </div>
        </AppContext>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
)(UserEditHeader)
